import React from 'react';

const reasons = [
  {
    title: "Temporary VPN access",
    desc: "Choose a VPN pass for the time you need, from one hour to 30 days, without starting an ongoing subscription."
  },
  {
    title: "Travel connectivity",
    desc: "Choose travel eSIM data for your destination and trip length without relying on your normal roaming plan."
  },
  {
    title: "Public Wi-Fi",
    desc: "Protect your connection when using hotel, airport, café and other shared networks."
  },
  {
    title: "A separate number when needed",
    desc: "Use a temporary UK or USA number for supported calls and messages without another physical SIM."
  },
  {
    title: "No unnecessary ongoing subscription",
    desc: "Pay once for the service and duration you choose. Nothing renews automatically."
  }
];

const WhyChoosePP = () => {
  return (
    <section id="why-people-use" className="py-10 px-4 md:py-12 bg-[#0d0d0d] relative">
      <div className="container mx-auto max-w-6xl">
        <h2 className="mb-12 w-fit max-w-2xl border-b-2 border-white/20 pb-2 text-2xl font-bold leading-tight text-white md:mb-14 md:text-4xl">Why people use PhantomPath</h2>

        <div className="grid gap-x-16 gap-y-10 md:grid-cols-2 md:gap-y-12">
          {reasons.map((reason) => (
            <article key={reason.title} className="grid content-start gap-3 sm:grid-cols-[minmax(0,0.42fr)_minmax(0,0.58fr)] sm:gap-6">
              <h3 className="text-lg font-bold leading-snug text-white md:text-xl">{reason.title}</h3>
              <p className="text-sm leading-relaxed text-gray-400">{reason.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChoosePP;
